import script from "./UpcomingDrawsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingDrawsView.vue?vue&type=script&setup=true&lang=ts"

import "./UpcomingDrawsView.vue?vue&type=style&index=0&id=22b35462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b35462"]])

export default __exports__